
import { Component, Mixins } from "vue-property-decorator";
import { AxiosInstance } from "axios";

import {
  MyChatEntry,
  ChatEntry,
  ChatResponse
} from "@/interfaces/meeting/details";
import { sendMessage } from "@/services/api/meeting";
import { sendUpdateChat } from "@/services/meeting/messaging";
import { JsonConsoleLogger } from "@/services/logging/consoleLogger";
import { loadMeetingState } from "@/services/api/meeting";
import SoundMixin from "@/mixins/SoundMixin.vue";

@Component({
  data() {
    return {
      chatEntries: []
    };
  }
})
export default class ChatMixin extends Mixins<SoundMixin>(SoundMixin) {
  chatEntries!: ChatEntry[];
  hasNewMessages = false;

  async sendChatEntry(
    apiClient: AxiosInstance,
    userId: string,
    name: string,
    content: string
  ) {
    const chatEntry: MyChatEntry = {
      userId,
      name,
      content
    };
    // Send chat entry to the backend
    const response = await sendMessage(apiClient, chatEntry);
    this.chatEntries = response.chat;
    // Trigger the "update_chat" socket event
    sendUpdateChat(userId);
  }

  async loadChats(
    { sender }: { sender: string },
    logger: JsonConsoleLogger,
    apiClient: AxiosInstance,
    shouldShowBadge: boolean // if drawer is shrink, should show badge
  ) {
    logger.info(
      "[CHAT] Chats were updated, will load chats from server. Update was sent by ",
      sender
    );
    let { chat } = await loadMeetingState<ChatResponse>(apiClient, "chat");
    // Happens when no state has yet been defined
    if (!chat) {
      chat = [];
    }
    this.chatEntries = chat;
    // Initial load, the sender is empty
    if (sender) {
      this.playNotification();
      if (shouldShowBadge) {
        this.hasNewMessages = true;
      }
    }
  }

  clearHasNewMessages() {
    this.hasNewMessages = false;
  }
}
